import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AhamLogo from '../../img/Aham.png';

const Preloader = ({ isLoading }) => {
    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ opacity: 1 }}
                    exit={{
                        opacity: 0,
                        transition: { duration: 0.8, ease: "easeInOut" }
                    }}
                    className="fixed inset-0 z-[10000] flex items-center justify-center bg-white"
                >
                    <div className="relative flex flex-col items-center">
                        {/* Outer Glow Effect */}
                        <motion.div
                            initial={{ scale: 0.8, opacity: 0.5 }}
                            animate={{
                                scale: [0.8, 1.2, 0.8],
                                opacity: [0.3, 0.6, 0.3]
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                            className="absolute inset-0 bg-primary-100 blur-3xl rounded-full"
                        />

                        {/* Logo Animation */}
                        <motion.div
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{
                                duration: 0.5,
                                ease: "easeOut"
                            }}
                            className="relative z-10 mb-8"
                        >
                            <img
                                src={AhamLogo}
                                alt="AHAM Housing Finance"
                                className="w-48 md:w-64 h-auto object-contain"
                            />
                        </motion.div>

                        {/* Loading Indicator */}
                        <div className="relative w-48 h-1 bg-gray-100 rounded-full overflow-hidden">
                            <motion.div
                                initial={{ x: "-100%" }}
                                animate={{ x: "100%" }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                                className="absolute inset-0 bg-gradient-to-r from-transparent via-red-600 to-transparent w-full"
                            />
                        </div>

                        <motion.p
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3 }}
                            className="mt-4 text-primary-900 font-medium tracking-widest uppercase text-[10px]"
                        >
                            Housing For All
                        </motion.p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Preloader;
